module.exports = __webpack_public_path__ + "img/ag-analytics2.cc5b7399.png";